import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Select from "react-select";
import Pagination from "react-js-pagination";

import {
  showToast,
  addFeeToBundle,
  updateFeeDetails,
  getCreatedFeeDetails,
  assignFeeDues,
} from "../../actions";
import { isMobileDevice, convertToCurrencyFormat } from "../../helpers/Utils";
import { Text, Loader, ModalView } from "../common";
import StyleConstants from "../../shared/constants/styleConstants/styles";

const IS_MOBILE = isMobileDevice();

const customDropdownStyles = {
  control: (base) => ({
    ...base,
    height: 35,
    width: 350,
    backgroundColor: "white",
    border: "1px solid #CDCFD6",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 35,
  }),
  valueContainer: (base) => ({
    ...base,
    height: 35,
    overflow: "auto",
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
    color: state.isFocused ? "#FFF" : "#000",
    backgroundColor: state.isFocused && "#3994AE",
  }),
};

class Edit extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      displayFeeForm: false,
      displayFeeDueForm: false,
      priorityError: null,
      feeAccountError: "",
      newFeeDetails: {
        name: "",
        tax: "",
        totalAmount: "",
        priority: "",
        dueDate: "",
        feeAccountID: null,
      },
      currentFeeDetails: {
        name: "",
        tax: "",
        totalAmount: "",
        priority: "",
        dueDate: "",
        feeAccountID: null,
      },
      page: 1,
      perPage: 5,
      selectedTypeToAssignDue: "",
      selectedFee: {},
      showFeeDueAssignmentModal: false,
      showEditModal: false,
      listToChooseFrom: [],
      selectedItemsToAssignDue: [],
      selectedPageType: null,
      studentId: null,
    };
    this.handleCloseFeeDueAssignmentModal =
      this.handleCloseFeeDueAssignmentModal.bind(this);
    this.handleCloseEditModal = this.handleCloseEditModal.bind(this);
    this.handleChangeOfSingleSelect =
      this.handleChangeOfSingleSelect.bind(this);
    this.handleChangeOfMultiSelect = this.handleChangeOfMultiSelect.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  renderSubHeading(text) {
    return (
      <Text
        color={StyleConstants.textColor.primary}
        fontSize={StyleConstants.textSize.secondaryHeader}
        fontWeight={StyleConstants.textWeight.bold}
        style={{ textDecoration: "underline" }}
        text={text}
      />
    );
  }

  handleCloseEditModal() {
    this.setState({ showEditModal: false });
  }

  handleFormSubmit(event, isEditForm) {
    event.preventDefault();
    const { newFeeDetails, currentFeeDetails } = this.state;
    const feeDetails = isEditForm ? currentFeeDetails : newFeeDetails;
    const { name, tax, totalAmount, dueDate, priority, feeAccountID } =
      feeDetails;
    const detailsForSubmission = {
      name,
      fee_bundle_id: this.props.feeBundleId,
      fee_account_id: feeAccountID,
      tax,
      total_amount: totalAmount,
      due_date: dueDate,
      priority,
    };
    if (!feeAccountID) {
      this.setState({ feeAccountError: "Select a Fee Account" });
      return;
    }
    if (isEditForm) {
      this.props
        .updateFeeDetails(detailsForSubmission, feeDetails.id)
        .then((response) => {
          if (response.success) {
            this.handleCloseEditModal();
          }
        });
    } else {
      this.props.addFeeToBundle(detailsForSubmission).then((response) => {
        if (response.success) {
          this.setState({
            newFeeDetails: {
              name: "",
              tax: "",
              totalAmount: "",
              priority: "",
              dueDate: Date.now(),
            },
            displayFeeForm: false,
            showFeeDueAssignmentModal: false,
          });
        }
      });
    }
  }

  handleInputChange(event, type, isEditForm) {
    if (isEditForm) {
      this.setState({
        currentFeeDetails: {
          ...this.state.currentFeeDetails,
          [type]: event.target.value,
        },
      });
    } else {
      this.setState({
        newFeeDetails: {
          ...this.state.newFeeDetails,
          [type]: event.target.value,
        },
      });
    }
  }

  handleCloseFeeDueAssignmentModal() {
    this.setState({
      selectedTypeToAssignDue: "",
      selectedItemsToAssignDue: [],
      showFeeDueAssignmentModal: false,
    });
  }

  handleChangeOfSingleSelect(selectedOption) {
    const { showEditModal } = this.state;
    const key = showEditModal ? "currentFeeDetails" : "newFeeDetails";
    this.setState({
      feeAccountError: "",
      [key]: {
        ...this.state[key],
        feeAccountID: selectedOption.value,
      },
    });
  }

  handleChangeOfMultiSelect(selectedOptions) {
    this.setState({ selectedItemsToAssignDue: selectedOptions });
  }

  renderSingleSelect(options, selectedOption, placeholder) {
    return (
      <Select
        value={selectedOption}
        onChange={this.handleChangeOfSingleSelect}
        options={options}
        placeholder={placeholder}
        styles={customDropdownStyles}
        isSearchable
      />
    );
  }

  renderFeeForm(isEditForm = false) {
    const { feeAccounts } = this.props;
    const { newFeeDetails, currentFeeDetails } = this.state;
    const feeDetails = isEditForm ? currentFeeDetails : newFeeDetails;
    const { name, tax, totalAmount, dueDate, priority, feeAccountID } =
      feeDetails;
    const selectedFeeAccount = feeAccounts.find(
      (account) => parseInt(account.id, 10) === parseInt(feeAccountID, 10)
    );
    const labelStyle = {
      display: "flex",
      justifyContent: "flex-start",
      width: 100,
    };
    const containerStyle = {
      display: "flex",
      margin: "10px 0px",
      maxWidth: 700,
      alignItems: "center",
    };

    if (this.props.updateFeeLoader) {
      return <Loader height={300} />;
    }

    return (
      <form onSubmit={(event) => this.handleFormSubmit(event, isEditForm)}>
        <fieldset
          style={{ width: isEditForm ? !IS_MOBILE && 570 : !IS_MOBILE && 750 }}
        >
          <legend>Fee Details:</legend>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="fee_name">
              Name:
            </label>
            <input
              value={name}
              onChange={(event) =>
                this.handleInputChange(event, "name", isEditForm)
              }
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              type="text"
              name="fee_name"
              id="fee_name"
              maxLength="100"
              required
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="fee_tax">
              Tax (%):
            </label>
            <input
              value={tax}
              onChange={(event) =>
                this.handleInputChange(event, "tax", isEditForm)
              }
              style={{ marginLeft: 10, width: !IS_MOBILE && 100 }}
              type="number"
              min="0"
              name="fee_tax"
              id="fee_tax"
              step="0.1"
              required
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="fee_amount">
              Total including GST:
            </label>
            <input
              value={totalAmount}
              onChange={(event) =>
                this.handleInputChange(event, "totalAmount", isEditForm)
              }
              style={{ marginLeft: 10, width: !IS_MOBILE && 100 }}
              type="number"
              min="1"
              name="fee_amount"
              id="fee_amount"
              step="0.01"
              required
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="priority">
              Priority:
            </label>
            <input
              value={priority}
              onChange={(event) => {
                if (
                  event.target.value >
                  this.props.feeDetails.length + (isEditForm ? 0 : 1)
                ) {
                  this.setState({
                    priorityError: `Value should be less than ${
                      this.props.feeDetails.length + (isEditForm ? 1 : 2)
                    }`,
                  });
                  return;
                }
                this.setState({ priorityError: null });
                this.handleInputChange(event, "priority", isEditForm);
              }}
              style={{ marginLeft: 10, width: !IS_MOBILE && 100 }}
              type="number"
              min="1"
              max={this.props.feeDetails.length + 1}
              name="priority"
              id="priority"
              step="1"
              required
              aria-required="true"
            />
          </div>
          {!!this.state.priorityError && (
            <div style={{ fontSize: 14, color: "red" }}>
              {this.state.priorityError}
            </div>
          )}
          <div style={{ display: "flex", alignItems: "center" }}>
            <label style={labelStyle} htmlFor="fee_account_id">
              Fee Account:
            </label>
            <div style={{ marginLeft: 10 }}>
              {this.renderSingleSelect(
                feeAccounts.map((account) => {
                  return { value: account.id, label: account.name };
                }),
                selectedFeeAccount
                  ? {
                      label: selectedFeeAccount.name,
                      value: selectedFeeAccount.id,
                    }
                  : null,
                "Select Fee Account"
              )}
            </div>
          </div>
          {!!this.state.feeAccountError && (
            <div style={{ marginTop: 10, fontSize: 14, color: "red" }}>
              {this.state.feeAccountError}
            </div>
          )}
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="fee_due_date">
              Due Date:
            </label>
            <input
              value={dueDate}
              onChange={(event) =>
                this.handleInputChange(event, "dueDate", isEditForm)
              }
              style={{ marginLeft: 10 }}
              type="date"
              name="fee_due_date"
              id="fee_due_date"
              required
              aria-required="true"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: IS_MOBILE ? "center" : "flex-start",
            }}
          >
            <button
              type="submit"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 180,
                height: 35,
                backgroundColor: StyleConstants.color.darkBlue,
                borderColor: StyleConstants.color.darkBlue,
                color: "#FFFFFF",
                borderRadius: 4,
                lineHeight: 0,
                fontSize: 14,
                cursor: "pointer",
                marginTop: 10,
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              Submit
            </button>
          </div>
        </fieldset>
      </form>
    );
  }

  renderFeeCreationPart() {
    const { feeBundles } = this.props;
    const { displayFeeForm } = this.state;
    const selectedFeeBundle = feeBundles.find(
      (feeBundle) => feeBundle.id === this.props.feeBundleId
    );
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "10px 50px 30px",
        }}
      >
        {!displayFeeForm && selectedFeeBundle.active && (
          <div
            className="Button Primary-Button"
            style={{ width: 150 }}
            onClick={() => this.setState({ displayFeeForm: true })}
          >
            Create Fee
          </div>
        )}
        {this.state.displayFeeForm && this.renderFeeForm()}
      </div>
    );
  }

  renderModal() {
    const { showEditModal } = this.state;
    return (
      <ModalView
        key={showEditModal}
        header={"Update Fee Details"}
        isModalVisible={showEditModal}
        handleCloseModal={this.handleCloseEditModal}
        width={600}
      >
        {this.renderFeeForm(true)}
      </ModalView>
    );
  }

  renderCreatedFeeDetails() {
    const { feeDetails, feeBundles, feeAccounts, isFinance } = this.props;
    const selectedFeeBundle = feeBundles.find(
      (feeBundle) => feeBundle.id === this.props.feeBundleId
    );
    const { page, perPage } = this.state;
    const headings = !isFinance && selectedFeeBundle.active
      ? [
          "Priority",
          "Name",
          "Amount",
          "Tax (%)",
          "Total",
          "Due Date",
          "Fee Account",
          "",
        ]
      : [
          "Priority",
          "Name",
          "Amount",
          "Tax (%)",
          "Total",
          "Due Date",
          "Fee Account",
        ];
    if (feeDetails.length === 0) {
      return (
        !this.state.displayFeeForm && (
          <div
            style={{
              textAlign: "center",
              fontSize: 20,
              fontWeight: 500,
              marginBottom: 15,
            }}
          >
            No Fees
          </div>
        )
      );
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px 50px",
          overflowX: "auto",
        }}
      >
        <table
          className="table table-bordered"
          style={{
            boxShadow: "1px 2px 6px #8B9DAF33",
            marginBottom: 10,
          }}
        >
          <thead>
            <tr
              style={{
                fontSize: 16,
                fontWeight: "700",
                height: 55,
                paddingLeft: 20,
              }}
            >
              {headings.map((heading, index) => {
                return (
                  <th
                    key={index + 1}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {heading.toLocaleUpperCase()}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {feeDetails
              .slice((page - 1) * perPage, page * perPage)
              .map((feeData, index) => {
                const day = new Date(feeData.due_date);
                const year = new Intl.DateTimeFormat("en", {
                  year: "2-digit",
                }).format(day);
                const month = new Intl.DateTimeFormat("en", {
                  month: "short",
                }).format(day);
                const date = new Intl.DateTimeFormat("en", {
                  day: "2-digit",
                }).format(day);
                const feeAccount = feeAccounts.find(
                  (account) => account.id === feeData.fee_account_id
                );
                const rowData = [
                  feeData.priority,
                  feeData.name,
                  feeData.amount.toFixed(2),
                  feeData.tax.toFixed(1),
                  feeData.total_amount.toFixed(2),
                  `${date} ${month} '${year}`,
                  feeAccount?.name,
                ];
                return (
                  <tr
                    key={rowData[0]}
                    style={{
                      fontSize: StyleConstants.textSize.subHeader,
                      color: "#343737",
                      fontWeight: "400",
                    }}
                  >
                    {rowData.map((key, columnIndex) => {
                      return (
                        <td
                          key={`${rowData[0]} - ${columnIndex}`}
                          role="presentation"
                          style={{
                            cursor:
                              columnIndex === rowData.length - 1
                                ? "auto"
                                : "pointer",
                            textAlign: [0, 2, 3, 4].includes(columnIndex)
                              ? "right"
                              : "left",
                          }}
                        >
                          {[2, 4].includes(columnIndex)
                            ? convertToCurrencyFormat(parseInt(key, 10))
                            : key}
                        </td>
                      );
                    })}
                    {!isFinance && selectedFeeBundle.active && (
                      <td
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{ width: 100 }}
                          className="Button Secondary-Button"
                          aria-disabled
                          onClick={() =>
                            this.setState({
                              showEditModal: true,
                              currentFeeDetails: {
                                ...feeData,
                                totalAmount: feeData.total_amount,
                                dueDate: feeData.due_date,
                                feeAccountID: feeData?.fee_account_id,
                              },
                            })
                          }
                        >
                          Edit
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
        <Pagination
          activePage={page}
          itemsCountPerPage={perPage}
          totalItemsCount={feeDetails.length}
          pageRangeDisplayed={IS_MOBILE ? 3 : 10}
          onChange={(pageNumber) => this.setState({ page: pageNumber })}
        />
      </div>
    );
  }

  renderScreen() {
    const { isFinance } = this.props;
    return (
      <>
        {!isFinance && this.renderFeeCreationPart()}
        {this.renderCreatedFeeDetails()}
      </>
    );
  }

  render() {
    const { showEditModal } = this.state;
    return (
      <>
        {this.renderScreen()}
        {showEditModal && this.renderModal()}
      </>
    );
  }
}

Edit.propTypes = {
  isLoading: PropTypes.bool,
  feeBundles: PropTypes.array,
  campuses: PropTypes.array,
  classrooms: PropTypes.array,
  students: PropTypes.array,
  addFeeToBundle: PropTypes.func,
  getFeesInBundle: PropTypes.func,
};

Edit.defaultProps = {
  isLoading: false,
  feeBundles: [],
  campuses: [],
  classrooms: [],
  students: [],
};

const mapStateToProps = ({ home }) => ({
  isLoading: home.isLoading,
  feeAccounts: home.feeAccounts,
  feeBundles: home.feeBundles,
  campuses: home.campuses,
  classrooms: home.classrooms,
  students: home.students,
  updateFeeLoader: home.updateFeeLoader,
  isFinance: home.isFinance,
});

export default connect(mapStateToProps, {
  showToast,
  addFeeToBundle,
  updateFeeDetails,
  getCreatedFeeDetails,
  assignFeeDues,
})(Edit);
